// The whole AI team's calendar: every team's plans in one place.
import { TeamCalendar } from '@/pages/ai-team/workspace/TeamCalendar'

export function CalendarPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-neutral-900 dark:text-white">
          Calendar
        </h1>
        <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">
          Every agent's schedule and all content in one place. Pick what to see with the tabs.
        </p>
      </div>
      <TeamCalendar />
    </div>
  )
}
